import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: 'app-automations',
  templateUrl: './automations.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AutomationsComponent {
  @HostBinding('class')
  private readonly classes = 'flex flex-col w-full h-full bg-white border-l border-navy-40 overflow-hidden';

  buildTranslationKey(key: string): string {
    return `trustCenter.settings.automations.${key}`;
  }
}
